var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-content',{attrs:{"id":"homepage"}},[_c('section',[_c('v-parallax',{attrs:{"src":"/img/header-background.jpg","height":"450"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }